import React, { useMemo } from 'react';
import CookiePolicyTripUK from '../../components/CookiePolicyTripUK';
import CookiePolicyGeneric from '../../components/CookiePolicyGeneric';
import CookiePolicyUSChubb from '../../components/CookiePolicyUSChubb';
import CookiePolicyUSMetlife from '../../components/CookiePolicyUSMetlife';
import CookiePolicyUSTI from '../../components/CookiePolicyUSTI';
import CookiePolicyWwiis from '../../components/CookiePolicyWwiis';
import CookiesPolicyGlobalUS from '../../components/CookiePolicyGlobalUS';
import CookiesPolicy from '../../components/CookiesPolicy';
function Cookie() {
  const currentDomain = window.location.hostname;

  const activeDomain = useMemo(() => {
    const domainMap = {
      [import.meta.env.VITE_DOMAIN_GENERIC]: 'generic',
      [import.meta.env.VITE_DOMAIN_TRIPUK]: 'tripuk',
      [import.meta.env.VITE_DOMAIN_US]: 'globalus',
      [import.meta.env.VITE_DOMAIN_US_CHUBB]: 'uschubb',
      [import.meta.env.VITE_DOMAIN_US_METLIFE]: 'usmetlife',
      [import.meta.env.VITE_DOMAIN_USTI]: 'usti',
      [import.meta.env.VITE_DOMAIN_WWIIS]: 'wwiis',
    };
    return domainMap[currentDomain] || 'default';
  }, [currentDomain]);

  return (
    <div className="container">
      <div className="dialog">
        {activeDomain === 'default' && <CookiesPolicy />}
        {activeDomain === 'tripuk' && <CookiePolicyTripUK />}
        {activeDomain === 'generic' && <CookiePolicyGeneric />}
        {activeDomain === 'uschubb' && <CookiePolicyUSChubb />}
        {activeDomain === 'globalus' && <CookiesPolicyGlobalUS />}
        {activeDomain === 'usmetlife' && <CookiePolicyUSMetlife />}
        {activeDomain === 'usti' && <CookiePolicyUSTI />}
        {activeDomain === 'wwiis' && <CookiePolicyWwiis />}
      </div>
    </div>
  );
}

export default Cookie;
